import Order from './Order'
import OrderDetails from './OrderDetails'
import ExtraServices from './ExtraServices'
import AdditionalServices from './AdditionalServices'
import ThankYouPage from './ThankYouPage'

export default {Order, OrderDetails, ExtraServices, AdditionalServices, ThankYouPage}
